import { lightModeTheme, lightStatusColor } from 'themes/modes/light_mode_theme'
import { ThemeProvider } from '@mui/material'
import { PropsWithChildren } from 'react'
import { StatusColor } from 'themes/modes/common_theme'

/**
 * comstruct ThemeContext
 * @category Themes
 */
interface ThemeContext {
  /** Theme's Status color */
  statusColor: StatusColor
}

/**
 * useComstructThemeContext hook returns a ThemeContext if it exists, otherwise throws an error.
 * The theme context provides the current theme and a method to set the theme.
 * @remarks This hook must be used within a ComstructThemeProvider
 * @returns ThemeContext
 * @category Themes
 */
export function useComstructThemeContext(): ThemeContext {
  return {
    statusColor: lightStatusColor,
  }
}

/**
 * ComstructThemeProvider component provides a Theme context to its children
 * @param props
 * @class
 */
const ComstructThemeProvider = (props: PropsWithChildren) => {
  const { children } = props
  return <ThemeProvider theme={lightModeTheme}>{children}</ThemeProvider>
}

export default ComstructThemeProvider
